import { APP } from 'config';
import { AppLanguage, appLanguages } from 'types/general';
import { capitalizeFirstLetter, includes } from 'utils/general';

// Browsers without locale data for these codes fall back to English.
const NATIVE_LANGUAGE_NAMES: Partial<Record<AppLanguage, string>> = {
  is: 'Íslenska',
  ka: 'ქართული',
  mk: 'Македонски',
  sq: 'Shqip',
};

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DisplayNames/DisplayNames
export const formatLanguage = (language: string, code: string): string => {
  const normalizedCode = code.toLowerCase();

  if (
    language.toLowerCase() === normalizedCode &&
    includes(appLanguages, normalizedCode) &&
    NATIVE_LANGUAGE_NAMES[normalizedCode]
  ) {
    return NATIVE_LANGUAGE_NAMES[normalizedCode];
  }

  const locale: AppLanguage = includes(appLanguages, language)
    ? language
    : APP.locales.default;

  const formated = new Intl.DisplayNames([locale], {
    type: 'language',
    languageDisplay: 'standard',
    style: 'short',
  }).of(normalizedCode === 'gb' ? 'en-GB' : code);

  return capitalizeFirstLetter(formated) || code;
};
